// The field Tab goes to after `from`: the first element after it on the page that takes
// focus. A suggestion list that takes the highlighted row on Tab needs it, because the
// input Tab was pressed in is gone by the time the browser would move on from it.

const FOCUSABLE =
  'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

export function nextFocusable(from: Element | null): HTMLElement | null {
  if (!from) return null;
  for (const element of Array.from(document.querySelectorAll<HTMLElement>(FOCUSABLE))) {
    if (from.contains(element)) continue;
    if (!(from.compareDocumentPosition(element) & Node.DOCUMENT_POSITION_FOLLOWING)) continue;
    // Not drawn: display none, or inside a closed section.
    if (element.getClientRects().length === 0) continue;
    return element;
  }
  return null;
}

/** Focus what came after `from` once the choice has been drawn. */
export function focusNextAfterChoice(next: HTMLElement | null): void {
  if (next) window.setTimeout(() => next.focus(), 0);
}
